import { NavLink } from "react-router-dom";

/** 售价管理中心 5 page 共用子导航（每页顶部·跨页跳转一致）。 */
const TABS = [
  { to: "/admin/pricing", label: "售价总览", end: true },
  { to: "/admin/pricing/channels", label: "渠道与系数", end: false },
  { to: "/admin/pricing/customer-prices", label: "客户专属价", end: false },   // PRICE-CUST-1
  { to: "/admin/pricing/sell-config", label: "售价配置", end: false },
];

export function PricingSubnav() {
  return (
    <div className="flex flex-wrap gap-1 rounded-xl border border-slate-200 bg-white p-1">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            `rounded-lg px-4 py-2 text-[13px] font-medium transition-colors ${
              isActive ? "bg-blue-600 text-white" : "text-slate-600 hover:bg-slate-100"
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
